import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader, Type } from "@similarweb/ui-components";

import { headerDataAutomation } from "app/pages/activation/components/Header/dataAutomationKeys";

import * as SC from "./styles";
import type { FlatDropdownButtonSchema } from "./type";

export const FlatDropdownButton = ({ icon, onClick, text, isLoading }: FlatDropdownButtonSchema) =>
    isLoading ? (
        <PixelPlaceholderLoader
            height="40px"
            width="300px"
        />
    ) : (
        <SC.FlatButtonWrapper
            onClick={onClick}
            data-automation={headerDataAutomation.dropdownButton}
        >
            <SC.CustomItemIcon
                iconType={Type.Website}
                iconSrc={icon}
            />
            <SC.TextContainer>{text}</SC.TextContainer>

            <SC.IconContainer>
                <SC.DropdownIcon
                    iconName="arrow"
                    iconColor={colorsPalettes.carbon[500]}
                    size="12px"
                />
            </SC.IconContainer>
        </SC.FlatButtonWrapper>
    );

FlatDropdownButton.displayName = "FlatDropdownButton";
